import {Component, ContentChild, Input, OnDestroy} from "@angular/core";
import {FUIOptionsService, SelectionsEvent} from "../../framework/options.service";
import {FUIAbstractOptions} from "../../framework/abstract-options";
import {Subscription} from "rxjs";
import {FUIClearButtonComponent} from "../../../buttons/button/clear-button/clear-button.component";

@Component({
    selector: "fui-multiselect-options",
    styleUrls: ["./multiselect-options.component.scss"],
    templateUrl: "./multiselect-options.component.html"
})
export class FUIMultiselectOptionsComponent extends FUIAbstractOptions implements OnDestroy {
    @Input() allowLabelMarkup: boolean = false;
    @ContentChild(FUIClearButtonComponent) public clearButton: FUIClearButtonComponent;
    private subscriptions: Subscription = new Subscription();

    constructor(optionsService: FUIOptionsService) {
        super(optionsService);
    }

    ngOnInit(): void {
        this.subscriptions.add(this.optionsService.selections$.subscribe(
            (event: SelectionsEvent) => {
                this._selections = event.selections;
                this.selections$.emit(event);
            }
        ));

        this.subscriptions.add(this.optionsService.changeSelections$.subscribe(
            (selections: SelectionsEvent) => {
                this.changeSelections$.emit(selections);
            }
        ));
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    /**
     * Set the selection selected to null
     */
    public unselect(): void {
        this.optionsService.selections = null;
    }
}
